document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".product-card");

  cards.forEach(card => {
    const link = card.querySelector("a.product-card__link");
    if (!link) return;

    let tappedOnce = false;

    link.addEventListener("touchstart", function (e) {
      if (!tappedOnce) {
        // First tap = zoom only
        e.preventDefault();
        tappedOnce = true;
        card.classList.add("zoom-active");
      } else {
        // Second tap = follow link
        window.location.href = link.getAttribute("href");
      }
    });
  });
});
